<template>
  <div>
    <template v-if="buttonInfo.url">
      <BaseButtonLink
        size="full"
        :text="buttonInfo.text"
        :styleType="buttonInfo.styleType"
        :classes="buttonInfo.classes"
        :to="buttonInfo.url"
      />
    </template>
    <template v-else-if="buttonInfo.scrollTo">
      <BaseButton
        size="full"
        :text="buttonInfo.text"
        :styleType="buttonInfo.styleType"
        :classes="buttonInfo.classes"
        @click="scrollTo(buttonInfo.scrollTo)"
      />
    </template>
    <template v-else-if="buttonInfo.modalId == 'main'">
      <BaseButton
        size="full"
        :text="buttonInfo.text"
        :styleType="buttonInfo.styleType"
        :classes="buttonInfo.classes"
        @click="showMainModal"
      />
    </template>
    <template v-else>
      <BaseButton
        size="full"
        :text="buttonInfo.text"
        :styleType="buttonInfo.styleType"
      />
    </template>
  </div>
</template>

<script setup>
defineProps({
  buttonInfo: Object,
});

const scrollTo = (id) => {
  const position = findPosition(document.getElementById(id));
  window.scroll(0, position[0] - 100);
};

const findPosition = (obj) => {
  var currenttop = 0;
  if (obj.offsetParent) {
    do {
      currenttop += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return [currenttop];
  }
};

const isMainModalShowState = useState("isMainModalShow");

const showMainModal = () => {
  isMainModalShowState.value = true;
};
</script>
